(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('[data-live-filter]').each(function () {
		var container = $(this);
		var triggers = container.find('[data-live-filter-trigger]');
		var targets = container.find('[data-live-filter-target]');

		triggers.on('click', function (e) {
			e.preventDefault();
			triggers.removeClass('live-filter-active');

			var trigger = $(this).addClass('live-filter-active');
			var show = trigger.attr('data-live-filter-trigger').split(' ');

			// Show all
			if (show.length && show[0] === '__all') {
				targets.removeClass('live-filter-hide');
				container.trigger('live-filter', ['__all']);
			}
			// Show some
			else {
				targets.removeClass('live-filter-hide').filter(function () {
					var target = $(this);
					var has = target.attr('data-live-filter-target').split(' ');
					var hide = true;

					$.each(has, function (k, v) {
						if ($.inArray(v, show) !== -1) {
							hide = false;
						}
					});

					return hide;
				}).addClass('live-filter-hide');

				container.trigger('live-filter', show);
			}
		});

		// Select potential default
		triggers.filter('[data-live-filter-selected]').click();
	});
})();
